import React from 'react';
import FileUploadContent from '../FileUpload';

const UploadPage = () => {
  return <FileUploadContent />;
};

export default UploadPage;
